import { RouterDevtools } from "util/RouterDevtools";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import Notifier from "containers/Shared/Notifier";
import saga from "containers/Shared/App/saga";
import { useInjectSaga } from "utils/injectSaga";

import { NotFoundPage } from "lib/error/NotFoundPage";
import { LegacyQueryParamProvider } from "providers/layout/LegacyQueryParamProvider";
import { ThirdPartyIntegrationLoader } from "lib/thirdparty/ThirdPartyIntegrationLoader";
import { SkipToMainContentLink } from "components/common/SkipToMainContentLink";
import { PageTitle } from "components/layouts/PageTitle";
import { RouteAnnouncer } from "components/layouts/RouteAnnouncer";
import { useGetLogoBranding } from "generated/api/platform-branding/platform-branding";
import { AuthTokenDetector } from "core/iam/AuthTokenDetector";

export const Route = createRootRoute({
  component: () => {
    useInjectSaga({ key: "app", saga });
    const { data: theme } = useGetLogoBranding();

    return (
      <AuthTokenDetector>
        <LegacyQueryParamProvider>
          <ThirdPartyIntegrationLoader />
          <Notifier />
          <SkipToMainContentLink />
          <RouteAnnouncer />
          <PageTitle
            titleTemplate={` | ${theme?.browserTitle ?? "CommunityCliQ"}`}
          >
            <Outlet />
          </PageTitle>
          <RouterDevtools disable />
        </LegacyQueryParamProvider>
      </AuthTokenDetector>
    );
  },
  notFoundComponent: NotFoundPage,
});
